import { ReactNode } from "react";

import css from "./StickyActionBar.module.scss";

interface StickyActionBarProps {
  children: ReactNode;
  hint?: ReactNode;
}

export const StickyActionBar = ({ children, hint }: StickyActionBarProps) => {
  return (
    <div className={css.bar}>
      <div className={css.inner}>
        <div className={css.actions}>{children}</div>
        {hint && <div className={css.hint}>{hint}</div>}
      </div>
    </div>
  );
};
